/**
 * Celeste Skin - Color schemes for Base components
 *
 * The celeste skin uses gradient-based player colors instead of flat colors.
 * Each scheme defines three gradient stops used for the two player-specific
 * quadrant fills (paint6 / paint7 in the SVG).
 */

export interface CelesteColorScheme {
  name: string;
  ariaLabel: string;
  /** Player color gradient start (leftmost stop) */
  gradientStart: string;
  /** Player color gradient middle (48% stop) */
  gradientMid: string;
  /** Player color gradient end (rightmost stop) */
  gradientEnd: string;
}

export const CELESTE_COLOR_SCHEMES = {
  blue: {
    name: 'blue',
    ariaLabel: 'Blue player home base',
    gradientStart: '#5FACD6',
    gradientMid: '#4584C7',
    gradientEnd: '#3B57A1'
  },
  green: {
    name: 'green',
    ariaLabel: 'Green player home base',
    gradientStart: '#5DD681',
    gradientMid: '#45B840',
    gradientEnd: '#3B8A38'
  },
  red: {
    name: 'red',
    ariaLabel: 'Red player home base',
    gradientStart: '#C06565',
    gradientMid: '#A04545',
    gradientEnd: '#853838'
  },
  yellow: {
    name: 'yellow',
    ariaLabel: 'Yellow player home base',
    gradientStart: '#E8C830',
    gradientMid: '#D4A520',
    gradientEnd: '#B08818'
  }
} as const satisfies Record<string, CelesteColorScheme>;
